var render, staticRenderFns
import script from "./endDetails.vue?vue&type=script&lang=js&"
export * from "./endDetails.vue?vue&type=script&lang=js&"
import style0 from "./endDetails.vue?vue&type=style&index=0&id=5fb2ecd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb2ecd6",
  null
  
)

export default component.exports